import React from 'react'

import API from 'utils/API'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Articles from 'components/organisms/Articles'

import config from 'config'

const { assets_url: assetsUrl } = config
const peluangAssetsPath = `${assetsUrl}/assets/img/peluang`

const PeluangArticle = () => (
  <div className="peluang-article">
    <SectionContainer backgroundColor="transparent">
      <Container>
        <Articles sourceUrl={`${API.endPoints().articles}?tags[]=679385605`} sectionTitle="Artikel Terkait" withSeeMore={false} global/>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .peluang-article {
          :global(.subtitle) {
            color: #fff;
            text-align: center;
            padding-bottom: 0 !important;
            font-size: 32px;
          }
          @media screen and (min-width: 768px) {
            background-image: linear-gradient(to bottom, #1d3f6c 50%, transparent 50%), url(${peluangAssetsPath}/bg-article-pc.svg);
            background-repeat: no-repeat, no-repeat;
            background-position: center;
            background-size: auto, contain;
          }
          
          background-image: linear-gradient(to bottom, #1d3f6c 50%, transparent 50%), url(${peluangAssetsPath}/bg-article-sp.svg);
          background-repeat: no-repeat, no-repeat;
          background-position: center;
          background-size: auto, contain;
        }
        :global(.quipper-articles) {
          padding: 0 !important;
        }
      `}
    </style>
  </div>
)

export default PeluangArticle
